import { render, staticRenderFns } from "./OrticPDFUploadDropZone.vue?vue&type=template&id=1106c7bd&scoped=true&"
import script from "./OrticPDFUploadDropZone.vue?vue&type=script&lang=js&"
export * from "./OrticPDFUploadDropZone.vue?vue&type=script&lang=js&"
import style0 from "./OrticPDFUploadDropZone.vue?vue&type=style&index=0&id=1106c7bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1106c7bd",
  null
  
)

export default component.exports